export const feedback = ({ ...data }) => {
    return {
        ...data,
    };
};
